import React from "react";
import EdicionSolicitud from "components/TableContainer/Solicitudes/EdicionSolicitud";

const EditarSolicitud = () => {
  return <EdicionSolicitud />;
};

export default EditarSolicitud;
